import { useStorage } from '@vueuse/core';
import { STORAGE_KEY_PROJECTS_VIEW } from '~/utilities/constants';

export type ListOrGrid = 'list' | 'grid';

export function useListGridViewPreference() {
  const savedView = useStorage<ListOrGrid>(STORAGE_KEY_PROJECTS_VIEW, 'grid');
  const toggleView = () => (savedView.value = savedView.value === 'list' ? 'grid' : 'list');

  return {
    savedView,
    toggleView,
  };
}
